import React from "react";

const TotalTips = ({ row }) => {
  return (
    <div>
      {row?.totalTips?.toLocaleString()
        ? row?.totalTips?.toLocaleString()
        : "-"}
    </div>
  );
};

export default TotalTips;
